import { Grid, Column, Title, SubTitle, Paragraph } from '@bidalihq/ui';
import Image from 'next/image';

import Section from '@/components/section';

const Openings = () => {
  return (
    <Section>
      <Title className="text-brand-primary">Careers</Title>
      <Grid columns={[1, 3]}>
        <Column span={[1, 2]}>
          <SubTitle className="italic mb-8">Do you want to make the global economy more inclusive?</SubTitle>
          <Paragraph>If the answer is <strong>yes</strong>, then you should consider a career at Bidali.</Paragraph>
          <Paragraph className="my-4">We&apos;re a team of builders, thinkers and dreamers - who love what we do. Using blockchain technology we’re building a platform that allows people to transact in a more open, secure, and efficient way.</Paragraph>
          <Paragraph>If you are passionate about using technology to empower others to make a meaningful impact in their own lives, then you&apos;ve found the right place.</Paragraph>
        </Column>
        <Column span={1}>
          <Image className="rounded-xl" height={366} src="/images/careers.jpg" alt="Two employees collaborating with their laptops" width={550} />
        </Column>
      </Grid>
    </Section>
  );
};

export default Openings;
